export default class Configuration {
    static DefaultPageSize = 10;
    static SortDirectionAscending = 1;
    static SortDirectionDescending = -1;
    static ToasterPosition = 'b-toaster-bottom-right';
    static ToasterVariantSuccess = 'success';
    static ToasterVariantError = 'danger';
    static ToasterVariantWarning = 'warning';
    static ToasterAutoHideDelay = 5000;
    static SupportedLocales = ['hr', 'en'];
    static DefaultLocale = 'en';
    static FallbackLocale = 'hr';
    static AzureAuthType = 'AzureAd';
    static MaxExportSize = 100000;
}